<div class="gp-card-shell profile-photo-card">
  <div class="gp-card-header">
    <div class="gp-card-icon"><i class="pi pi-image"></i></div>
    <div class="gp-card-title-wrap">
      <h3 class="gp-card-title">Profile photo</h3>
    </div>
  </div>

  <div class="profile-photo-content">
    <!-- Avatar preview -->
    <div class="photo-preview-wrap">
      <img [src]="profileImage" alt="Profile Photo" class="profile-img-preview" />
    </div>

    <!-- Helper text -->
    <div class="helper-text">
      This photo appears on your applicant profile.<br>
      PNG or JPG, at least 400&times;400px.
    </div>

    <!-- Update button -->
    <div class="actions">
      <label class="update-btn" [class.uploading]="isUploading">
        <i class="pi pi-upload"></i>
        <span>{{ isUploading ? 'Uploading...' : 'Update photo' }}</span>
        <div style="position: relative;">
          <app-image-crop-upload
              style="position: absolute; opacity: 0; width: 100%; height: 100%; top: 0; left: 0;"
              [aspectRatio]="1"
              borderType="profile"
              (imageCropped)="onProfileCropped($event)">
          </app-image-crop-upload>
        </div>
      </label>
    </div>
  </div>
</div>
